import { useEffect, useRef } from 'react';

const DEFAULT_POLL_INTERVAL = 3000;

export const useSessionDetailPolling = (
  sessionId,
  fetchSessionById,
  interval = DEFAULT_POLL_INTERVAL,
) => {
  const fetchRef = useRef(fetchSessionById);

  useEffect(() => {
    fetchRef.current = fetchSessionById;
  }, [fetchSessionById]);

  useEffect(() => {
    if (!sessionId) {
      return undefined;
    }

    let isCancelled = false;
    let intervalId;

    const bootstrapPolling = async () => {
      try {
        await Promise.resolve(fetchRef.current(sessionId, false));
        if (isCancelled) {
          return;
        }

        intervalId = setInterval(() => {
          fetchRef.current(sessionId, true);
        }, interval);
      } catch (error) {
        if (process.env.NODE_ENV !== 'production') {
          console.error('[SessionDetailPolling] initial fetch failed', error);
        }
      }
    };

    bootstrapPolling();

    return () => {
      isCancelled = true;
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [sessionId, interval]);
};
